import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=b5eb08ea"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbNavigation: require('/vercel/path0/components/shared/BreadcrumbNavigation.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default,ProductMain: require('/vercel/path0/components/shared/product/ProductMain.vue').default,ProductAccessories: require('/vercel/path0/components/shared/product/ProductAccessories.vue').default,ProductDescription: require('/vercel/path0/components/shared/product/ProductDescription.vue').default,ProductSpecification: require('/vercel/path0/components/shared/product/ProductSpecification.vue').default,ProductDocuments: require('/vercel/path0/components/shared/product/ProductDocuments.vue').default,ProductRelated: require('/vercel/path0/components/shared/product/ProductRelated.vue').default,SuggestedBlogPosts: require('/vercel/path0/components/shared/SuggestedBlogPosts.vue').default})
